<template>
  <div class="box">
    <table class="table is-fullwidth" v-show="!loading && docs.length > 0">
      <thead>
        <tr>
          <th>Visit Date</th>
          <th>Customer</th>
          <th>Contact</th>
          <th>Visit Type</th>
          <th>Service Type</th>
          <th>Status</th>
          <th>Engineer</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="service in docs" :key="service._id">
          <td>{{ service.visitedAt | date }}</td>
          <td>{{ service.customerName }}</td>
          <td>
            {{ service.contactPerson }}
            <p>{{ service.contactNumber }}</p>
          </td>
          <td>
            <span
              class="is-uppercase"
              :class="{
                'has-text-info': service.visitType === 'warranty',
                'has-text-warning': service.visitType === 'contract',
                'has-text-grey': service.visitType === 'free',
                'has-text-success': service.visitType === 'chargeable'
              }"
            >{{ service.visitType }}</span>
          </td>
          <td>
            <span
              class="is-uppercase"
              :class="{
                'has-text-info': service.serviceType === 'installation',
                'has-text-danger': service.serviceType === 'breakdown',
                'has-text-warning': service.serviceType === 'maintenance'
              }"
            >{{ service.serviceType }}</span>
          </td>
          <td>
            <span
              class="is-uppercase"
              :class="{
                'has-text-success': service.status === 'completed',
                'has-text-warning': service.status === 'pending'
              }"
            >{{ service.status }}</span>
          </td>
          <td>
            <strong>{{ service.engineer.employeeId }}</strong>
            <p>{{ service.engineerName }}</p>
            <p>{{ service.engineerMobile }}</p>
          </td>
          <td>
            <router-link :to="`/request/service/view/${service._id}`">View</router-link>
            <p>
              <router-link :to="`/request/service/edit/${service._id}`">Edit</router-link>
            </p>
            <p>
              <router-link
                :to="`/request/service/delete/${service._id}`"
                class="has-text-danger"
              >Delete</router-link>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="has-text-centered">
      <button class="button is-loading is-large" v-show="loading"></button>
      <p
        class="has-text-grey"
        v-show="!loading && docs.length === 0"
      >No records matching these criteria</p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["service/docs"];
    },
    loading() {
      let component = this;
      return component.$store.getters["service/loading"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("service/index");
  }
};
</script>
<style lang="scss" scoped>
.actions {
  a {
    padding-right: 16px;
  }
}
button.is-loading {
  border: none;
}
</style>
